/* LUGAZI start page, shorter (24 Oct, Leandro: "lägg mina teckningar i tv istället för att man behöver skrolla förbi dom"):
   - every plain drawing of the book (the collage pages, the book pages of the sideways rail, the two drawn scenes after the
     player) moves into a stack of old TVs. The TVs switch channel now and then (snow), tap one and the drawing opens big,
     swipe / arrows to zap through all of them, the "SHOP" button shows when the drawing is a print you can buy.
   - three CCTV cameras hang next to the TVs and turn after your finger / mouse.
   - the scroll scenes that move (ring, cone, the two souls, love, the mannequins, the spinning angels) stay, but each one
     takes less scrolling, and the big empty space before the waiting list is gone.
   - the end: LUGAZI in ransom-note letters (each letter its own thing), and a hand holds on to the edge of the footer.
   Pictures are in lugazi-tv-N.js (TVs + cameras) and lugazi-end-N.js (letters + hand).
   Taking the script line out of lugazi-controls puts the page back exactly as it was. */
(function () {
  if (window.__lgzTv) return; window.__lgzTv = 1;
  var me = document.currentScript, V = '58330074', NTV = 6, NCAM = 3, NEND = 1, NEYE = 2;
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BOX = [[17.35, 6.23, 17.52, 12.16], [60.88, 2.89, 12.57, 13.37], [40.18, 17.93, 14.69, 11.09], [12.39, 24.01, 16.28, 12.31], [63.54, 20.06, 13.27, 11.85], [40.53, 34.19, 16.28, 10.49], [7.79, 41.49, 16.81, 12.31], [71.33, 37.08, 15.58, 11.85], [36.28, 45.74, 18.41, 13.07], [59.47, 53.5, 16.64, 8.66], [78.76, 53.65, 18.05, 12.92], [14.34, 58.51, 18.23, 13.53], [36.99, 62.46, 18.05, 13.22], [64.25, 62.61, 16.46, 12.92], [3.19, 76.6, 17.88, 13.37], [31.5, 80.7, 19.47, 13.68], [55.58, 79.79, 19.47, 14.29], [85.31, 76.44, 12.74, 13.22]];
  function part(pre, i, done) {
    if (!me || !me.src) return; var s = document.createElement('script');
    s.src = me.src.replace(/lugazi-tv\.js(\?.*)?$/, pre + '-' + i + '.js?v=' + V); s.onload = done; document.head.appendChild(s);
  }
  function loadAll(pre, n, done) { var left = n; for (var i = 1; i <= n; i++) part(pre, i, function () { if (!--left) done(); }); }
  function has(k) { var M = window.__lgzTvP; return M && M[k] && M[k].n && M[k].filter(Boolean).length === M[k].n; }
  function url(k) { return window.__lgzTvP[k].join(''); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }

  var book = document.querySelector('.lw-book-pages');
  if (!book) return;                       /* only the start page */
  document.documentElement.classList.add('lgz-tv-on');
  /* 24 Oct (test): the start page is short - first screen, the newest clothes, the TVs, the game, the waiting list.
     Everything else (player, ring, cone, souls, love, mannequins, angels) lives behind DRAWINGS+STUFF (?lugazi=book). */
  var compact = false;  /* 24 Oct 15:11: Leandro wants the long start page back (iPod, souls ...). Set back to !/[?&]lugazi=book/.test(location.search) for the short one. */
  if (compact) document.documentElement.classList.add('lgz-compact');

  /* ---------- styles ---------- */
  var st = document.createElement('style');
  st.textContent = [
    '.lgz-tv-gone{display:none!important}',
    'html.lgz-compact body:not(#lgzx) .lx-ipod:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-ring-chapter:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-cone:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-tired:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-figs:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-love-scene:not(#lgzx),html.lgz-compact body:not(#lgzx) .lgz-stage:not(#lgzx),html.lgz-compact body:not(#lgzx) .lgzj:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-spin-chapter:not(#lgzx),html.lgz-compact body:not(#lgzx) .lx-solo:not(#lgzx){display:none!important}',
    /* first screen: two of the metal signs as the two ways in */
    '.lgz-front{position:absolute;left:0;right:0;bottom:max(18px,3svh);display:flex;justify-content:center;align-items:flex-end;gap:clamp(10px,3vw,30px);z-index:7;padding:0 12px}',
    '.lgz-front{transition:opacity .25s}.lgz-front.off{opacity:0;pointer-events:none}',
    '.lgz-front a{display:block;line-height:0;-webkit-tap-highlight-color:transparent;transform-origin:50% 0;animation:lgz-fsw 4.4s ease-in-out infinite}',
    '.lgz-front a:nth-child(2){animation-duration:5.1s;animation-delay:-1.3s}',
    '.lgz-front img{display:block;width:100%;height:auto;filter:none!important}',
    '.lgz-front .f-shop{width:min(34vw,200px)}.lgz-front .f-draw{width:min(52vw,330px)}',
    '@keyframes lgz-fsw{0%,100%{rotate:-1.5deg}50%{rotate:1.5deg}}',
    '@media(hover:hover){.lgz-front a:hover{scale:1.05}}',
    'html.lgz-compact #lugazi-scene-1 .lx-down{display:none}',
    /* the newest clothes */
    '.lgz-drop{margin:clamp(40px,8svh,90px) 0 clamp(20px,4svh,40px)}',
    '.lgz-drop-h{display:block;width:min(40vw,190px);margin:0 auto 18px;line-height:0}.lgz-drop-h img{width:100%;height:auto}',
    '.lgz-drop-row{display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;padding:6px max(16px,calc(50vw - 560px)) 14px;-webkit-overflow-scrolling:touch;scrollbar-width:none}',
    '.lgz-drop-row::-webkit-scrollbar{display:none}',
    '.lgz-drop-card{flex:0 0 min(64vw,260px);scroll-snap-align:center;color:inherit;text-decoration:none;display:flex;flex-direction:column;gap:6px}',
    '.lgz-drop-card .im{aspect-ratio:4/5;display:flex;align-items:center;justify-content:center;background:transparent}',
    '.lgz-drop-card img{max-width:100%;max-height:100%;object-fit:contain;filter:none!important;transition:transform .35s cubic-bezier(.2,.9,.25,1.3)}',
    '@media(hover:hover){.lgz-drop-card:hover img{transform:rotate(-2deg) scale(1.04)}}',
    '.lgz-drop-card .t{font-family:"LUGAZI Hand","Inter",sans-serif;font-size:clamp(20px,5vw,26px);line-height:1.05}',
    '.lgz-drop-card .p{font-size:14px;opacity:.75}',
    '@media(min-width:750px){.lgz-drop-row{justify-content:center}}',
    /* each moving scene takes less scrolling */
    'html.lgz-tv-on body .lw-book .lw-book-pages > section.lx-figs.lx-figs{height:190svh!important}',
    'html.lgz-tv-on body .lw-book .lw-book-pages > section.lx-ring-chapter.lx-ring-chapter{height:125svh!important}',
    'html.lgz-tv-on body .lw-book .lw-book-pages > .lx-cone.lx-cone{height:118svh!important}',
    /* 25 Oct 03:16: the cone turns by itself (smooth), not with the scroll - a fast scroll made it jump (Leandro) */
    'html.lgz-tv-on .lx-cone-frames img{animation:lgz-cone 1.6s steps(1,end) infinite}',
    '@keyframes lgz-cone{0%{opacity:1}12.5%{opacity:0}100%{opacity:0}}',
    'html.lgz-tv-on .lx-cone-frames img:nth-child(1){animation-delay:0s}html.lgz-tv-on .lx-cone-frames img:nth-child(2){animation-delay:-1.4s}html.lgz-tv-on .lx-cone-frames img:nth-child(3){animation-delay:-1.2s}html.lgz-tv-on .lx-cone-frames img:nth-child(4){animation-delay:-1.0s}html.lgz-tv-on .lx-cone-frames img:nth-child(5){animation-delay:-0.8s}html.lgz-tv-on .lx-cone-frames img:nth-child(6){animation-delay:-0.6s}html.lgz-tv-on .lx-cone-frames img:nth-child(7){animation-delay:-0.4s}html.lgz-tv-on .lx-cone-frames img:nth-child(8){animation-delay:-0.2s}',
    '@media(prefers-reduced-motion:reduce){html.lgz-tv-on .lx-cone-frames img{animation:none}html.lgz-tv-on .lx-cone-frames img:first-child{opacity:1!important}}',
    'html.lgz-tv-on body .lw-book .lw-book-pages > section.lx-love-scene.lx-love-scene{height:112svh!important}',
    'html.lgz-tv-on body .lw-book .lw-book-pages > section.lgz-stage.lgz-stage{height:165svh!important}',
    'html.lgz-tv-on body .lw-book .lw-book-pages > section.lx-spin-chapter.lx-spin-chapter{height:150svh!important;margin-bottom:24px!important}',
    /* 24 Oct 22:30: the ransom letters are gone - his old LUGAZI logo flies big again at the end, as before (Leandro) */
    /* the TVs */
    '.lgz-tv{position:relative;width:min(94vw,620px);margin:clamp(10px,3svh,40px) auto clamp(40px,8svh,90px);padding-top:clamp(70px,13vw,120px)}',
    '.lgz-tv-stack{position:relative;width:100%;aspect-ratio:760/885}',  /* 24 Oct 22:18: back to his original stack - the TVs a bit crooked (Leandro) */
    '.lgz-tv-scr{position:absolute;display:block;padding:0;margin:0;border:0;background:#cfd6d8;overflow:hidden;cursor:pointer;-webkit-tap-highlight-color:transparent;border-radius:14%/18%}',
    '.lgz-tv-scr{background:#f7f6f2!important}',
    '.lgz-tv-scr .pic,.lgz-tvx-scr .pic{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}',
    '.lgz-tv-scr .pic>*{width:94%;height:94%;object-fit:contain;display:block;filter:none!important}',
    '.lgz-tvx-scr .pic>*{width:100%;height:100%;object-fit:contain;display:block;filter:none!important}',
    'html.lgz-dark .lgz-tv-scr .pic *,html.lgz-dark .lgz-tvx-scr .pic *{filter:none!important}',
    '.lgz-tv-scr::after{content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(160deg,rgba(255,255,255,.18),transparent 40%)}',
    '.lgz-snow{position:absolute;inset:0;pointer-events:none;opacity:0;background-size:96px 96px;animation:lgz-snow .18s steps(4) infinite}',
    '.zap .lgz-snow{opacity:1;transition:none}',
    '.lgz-snow{transition:opacity .25s}',
    '@keyframes lgz-snow{0%{background-position:0 0}25%{background-position:-31px 17px}50%{background-position:13px -41px}75%{background-position:-57px -9px}100%{background-position:0 0}}',
    '.lgz-tv-frame{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;opacity:0;transition:opacity .4s;filter:none!important}',
    '.lgz-tv-frame.on{opacity:1}',
    '@media(hover:hover){.lgz-tv-scr:hover img{filter:brightness(1.12) contrast(1.1)}}',
    '.lgz-tv-scr:focus-visible{outline:2px dashed #ff2b2b;outline-offset:2px}',
    /* the cameras */
    '.lgz-cams{position:absolute;right:-3%;top:0;width:clamp(130px,34%,220px);aspect-ratio:848/795;z-index:0;pointer-events:none}',
    '.lgz-cams>img{position:absolute;inset:0;width:100%;height:auto;filter:none!important}',
    '.lgz-cam{position:absolute;perspective:260px}',
    '.lgz-cam img{display:block;width:100%;height:auto;filter:none!important;transition:transform .7s cubic-bezier(.45,.05,.25,1);will-change:transform}',
    '.lgz-cam i{position:absolute;width:5px;height:5px;border-radius:50%;background:#ff1d1d;box-shadow:0 0 7px #ff1d1d;animation:lgz-rec 1.4s steps(2,jump-none) infinite}',
    '@keyframes lgz-rec{0%{opacity:1}100%{opacity:.1}}',
    '.lgz-tv-stack{z-index:1}',
    /* the drawing opened big */
    '.lgz-tvx{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.94);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;opacity:0;transition:opacity .2s;touch-action:pan-y}',
    '.lgz-tvx.on{opacity:1}',
    '.lgz-tvx-scr{position:relative;width:min(92vw,78svh,860px);height:min(72svh,110vw,900px);border-radius:3%/3.5%;overflow:hidden;background:#f2f2ee;box-shadow:0 0 0 10px #161616,0 0 0 12px #3a3a3a,0 0 60px rgba(160,200,255,.18)}',
    '.lgz-tvx-scr .pic{padding:2%}',
    
    '.lgz-tvx-bar{display:flex;align-items:center;gap:22px;color:#e8e8e8;font:600 15px/1 ui-monospace,Menlo,monospace;letter-spacing:.12em}',
    '.lgz-tvx-bar button,.lgz-tvx-x{background:none;border:0;color:#fff;cursor:pointer;padding:10px;font:400 26px/1 ui-monospace,Menlo,monospace;-webkit-tap-highlight-color:transparent}',
    '.lgz-tvx-x{position:absolute;top:max(10px,env(safe-area-inset-top));right:12px;font-size:30px}',
    '.lgz-tvx-ch{min-width:70px;text-align:center;color:#7dff7d;text-shadow:0 0 6px rgba(125,255,125,.6)}',
    '.lgz-tvx-buy{display:none;line-height:0}.lgz-tvx-buy.on{display:block}',
    '.lgz-tvx-buy img{width:130px;height:auto;filter:invert(1)!important}',
    'html.lgz-dark .lgz-tvx-buy img{filter:invert(1)!important}',
    /* the end: ransom letters + the hand */
    '.lgz-ransom{display:flex;align-items:flex-end;justify-content:center;gap:clamp(2px,1vw,10px);margin:0 auto 18px;height:clamp(64px,17vw,130px);cursor:default}',
    '.lgz-ransom img{height:100%;width:auto;filter:none!important;transform:rotate(var(--r)) translateY(var(--y));transition:transform .35s cubic-bezier(.2,.9,.25,1.6);-webkit-user-drag:none}',
    '.lgz-ransom img.bop{transform:rotate(calc(var(--r) * -2)) translateY(-14%) scale(1.08)}',
    '.lgz-ransom img[data-l=I]{height:96%}.lgz-ransom img[data-l=Z]{height:74%}.lgz-ransom img[data-l=U],.lgz-ransom img[data-l=G]{height:90%}',
    '#waitlist.lgz-has-ransom img.lgz-endlogo{display:none!important}',
    '.lgz-grip{position:absolute;left:19%;top:2%;width:18%;height:auto;z-index:3;cursor:pointer;-webkit-tap-highlight-color:transparent;filter:none!important;transform:translateY(-35%);opacity:0;transition:transform .8s cubic-bezier(.2,.9,.25,1.3),opacity .25s}',
    '.lgz-grip.on{transform:translateY(0);opacity:1}',
    '.lgz-grip.bye{transform:translateY(-140%) rotate(-8deg)!important;opacity:0!important;pointer-events:none;transition:transform .45s cubic-bezier(.5,0,.75,0),opacity .45s}',
    /* the PS2 TV in front of the stack (one more channel), the hidden key, the eye */
    '.lgz-ps2{position:absolute;left:-4%;bottom:-7%;width:27%;aspect-ratio:534/600;z-index:4}',
    '.lgz-ps2 > img{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;filter:none!important}',
    '.lgz-ps2 .lgz-tv-scr{border-radius:8%}',
    '.lgz-key{position:absolute;left:74%;top:4%;width:4.6%;padding:0;border:0;background:none;cursor:pointer;transform:rotate(28deg);transform-origin:50% 15%;-webkit-tap-highlight-color:transparent;animation:lgz-keyw 5s ease-in-out infinite}',
    '.lgz-key img{display:block;width:100%;height:auto;filter:none!important;pointer-events:none}',
    '@keyframes lgz-keyw{0%,100%{transform:rotate(28deg)}50%{transform:rotate(18deg)}}',
    '.lgz-key.spin{animation:lgz-keys .9s cubic-bezier(.3,.6,.3,1)}',
    '@keyframes lgz-keys{0%{transform:rotate(28deg) scale(1)}50%{transform:rotate(380deg) scale(1.8)}100%{transform:rotate(748deg) scale(1)}}',
    '.lgz-eye{position:absolute;left:4%;top:15%;width:min(23vw,100px);aspect-ratio:240/161;z-index:6;pointer-events:none}',
    '@media(min-width:750px){.lgz-eye{left:9%;top:38%;width:150px}}',
    '.lgz-eye img{position:absolute;filter:none!important}',
    '.lgz-eye .s,.lgz-eye .l{inset:0;width:100%;height:100%}',
    '.lgz-eye .i{left:36.8%;top:25.3%;width:28.85%;height:auto;transition:transform .18s ease-out}',
    '.lgz-eye.blink{animation:lgz-blink .22s ease-in-out}',
    '@keyframes lgz-blink{0%,100%{transform:scaleY(1)}50%{transform:scaleY(.08)}}',
    '@media(prefers-reduced-motion:reduce){.lgz-key{animation:none}.lgz-eye.blink{animation:none}}',
    '@media(prefers-reduced-motion:reduce){.lgz-snow{animation:none}.lgz-cam img,.lgz-ransom img,.lgz-grip{transition:none}}'
  ].join('');
  document.head.appendChild(st);

  /* ---------- snow ---------- */
  var SNOW = (function () {
    try {
      var c = document.createElement('canvas'); c.width = c.height = 96; var x = c.getContext('2d'), d = x.createImageData(96, 96);
      for (var i = 0; i < d.data.length; i += 4) { var v = Math.random() * 255 | 0; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = 255; }
      x.putImageData(d, 0, 0); return c.toDataURL();
    } catch (e) { return ''; }
  })();

  /* ---------- picture urls ---------- */
  function sized(u, w) {
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
    return u;
  }
  function key(u) { return (u || '').split('?')[0].split('/').pop(); }

  /* ---------- which parts of the page become channels ---------- */
  var KEEP = /collage-8135|collage-5894|collage-1359|ring-isolated|ring-hd|cone-\d/;
  var CH = [], seen = {};
  function pic(pg) {
    var im = pg.querySelector('img:not(.lx-ringhd):not(.lx-love-glow)'), u = '';
    if (im) u = im.getAttribute('src') || im.currentSrc || '';
    if (!u) { var si = pg.querySelector('svg image'); if (si) u = si.getAttribute('href') || si.getAttribute('xlink:href') || ''; }
    return u;
  }
  function addPage(pg) {
    var u = pic(pg); if (!u || KEEP.test(u)) return; var k = key(u); if (!k) return;
    /* the same drawing can be in the book twice (a page and a slide): one channel each */
    var bid = pg.dataset && pg.dataset.bookId; if (seen[k] || (bid && seen['b' + bid])) return; seen[k] = 1; if (bid) seen['b' + bid] = 1;
    CH.push({ u: u, pg: pg, svg: pg.querySelector('svg image') ? pg.querySelector('svg') : null });
  }
  function eligible(sec) {
    if (sec.classList.contains('lgz-tv-gone') || sec.classList.contains('lgz-tv')) return false;
    if (sec.matches('.lgz-gone,.lx-ring-chapter,.lgz-stage,.lx-spin-chapter,.lx-love-scene,.lgz-game,.lx-figs,.lx-cone,.lx-tired,.lgzj,.lgzj-breath,.lgz-ds-title,.lgz-ds-sub')) return false;
    if (!sec.matches('section.lw-collage-spread,section.lx-solo,section.lwa-rail')) return false;
    var u = [].map.call(sec.querySelectorAll('img,svg image'), function (i) { return i.getAttribute('src') || i.getAttribute('href') || ''; }).join(' ');
    if (KEEP.test(u)) return false;
    return !!sec.querySelector('.lw-collage-page');
  }
  function harvest() {
    var n0 = CH.length;
    ['#lugazi-scene-2', '#lugazi-scene-3'].forEach(function (q) {
      var s = document.querySelector(q); if (!s || s.classList.contains('lgz-tv-gone')) return;
      var a = s.querySelector('.lw-art'); if (a) addPage(a); s.classList.add('lgz-tv-gone');
    });
    [].forEach.call(book.children, function (sec) {
      if (!eligible(sec)) return;
      var pages = sec.matches('.lwa-rail') ? sec.querySelectorAll('.lgz-slide:not(.is-clone) .lw-collage-page, .lw-collage-page') : sec.querySelectorAll('.lw-collage-page');
      if (sec.matches('.lwa-rail') && !sec.querySelector('.lgz-slide')) return;   /* the rail is still being built */
      [].forEach.call(pages, addPage);
      sec.classList.add('lgz-tv-gone');
    });
    if (CH.length !== n0) fill();
  }

  /* ---------- the TV wall ---------- */
  var wall, screens = [], showing = [];
  function build() {
    wall = el('section', 'lgz-tv'); wall.setAttribute('aria-label', 'Drawings');
    var cams = el('div', 'lgz-cams'); cams.setAttribute('aria-hidden', 'true'); wall.appendChild(cams);
    var stack = el('div', 'lgz-tv-stack'); wall.appendChild(stack);
    BOX.forEach(function (b, i) {
      var s = el('button', 'lgz-tv-scr'); s.type = 'button';
      s.style.cssText = 'left:' + b[0] + '%;top:' + b[1] + '%;width:' + b[2] + '%;height:' + b[3] + '%';
      var im = new Image(); im.alt = ''; im.decoding = 'async'; im.loading = 'lazy'; s.appendChild(im);
      var sn = el('i', 'lgz-snow'); if (SNOW) sn.style.backgroundImage = 'url(' + SNOW + ')'; s.appendChild(sn);
      s.addEventListener('click', function () { if (showing[i] != null) open(showing[i]); });
      stack.appendChild(s); screens.push(s); showing.push(null);
      s.classList.add('zap');
    });
    /* the hidden key: hangs half behind the top right TV */
    var key = el('button', 'lgz-key'); key.type = 'button'; key.setAttribute('aria-label', 'Key'); stack.appendChild(key);
    key.addEventListener('click', jackpot);
    var fr = new Image(); fr.alt = ''; fr.className = 'lgz-tv-frame lgz-keep'; fr.setAttribute('aria-hidden', 'true'); stack.appendChild(fr);
    /* the PS2 TV in front: one more channel */
    var ps = el('div', 'lgz-ps2'), pb = PS2, sc = el('button', 'lgz-tv-scr'); sc.type = 'button';
    sc.style.cssText = 'left:' + pb[0] + '%;top:' + pb[1] + '%;width:' + pb[2] + '%;height:' + pb[3] + '%';
    var pim = new Image(); pim.alt = ''; pim.decoding = 'async'; pim.loading = 'lazy'; sc.appendChild(pim);
    var psn = el('i', 'lgz-snow'); if (SNOW) psn.style.backgroundImage = 'url(' + SNOW + ')'; sc.appendChild(psn);
    var n = screens.length; sc.addEventListener('click', function () { if (showing[n] != null) open(showing[n]); });
    ps.appendChild(sc); stack.appendChild(ps); screens.push(sc); showing.push(null); sc.classList.add('zap');
    book.insertBefore(wall, book.firstChild);
  }
  /* one drawing as it looks in the book: book pages keep their crop (no fingers) and their paper clean-up, cut-outs stay whole */
  var uid = 0;
  function render(c, w) {
    var ch = CH[c];
    /* 25 Oct 03:20 (Leandro): the start-page drawings are animated layers (masks that reveal while you scroll) - cloned
       mid-animation they showed a white band and seams. On the TVs they are simply the whole drawing. */
    if (ch.svg && (ch.svg.querySelectorAll('image').length > 1 || ch.svg.querySelector('mask'))) {
      var fi = ch.svg.querySelector('image'), fu = fi && (fi.getAttribute('href') || fi.getAttribute('xlink:href'));
      if (fu) { var pi = new Image(); pi.alt = ''; pi.decoding = 'async'; pi.src = sized(fu, w); return pi; }
    }
    if (ch.svg) {
      var sv = ch.svg.cloneNode(true), n = ++uid;
      [].forEach.call(sv.querySelectorAll('[id]'), function (d) {
        var o = d.id, nid = o + '-tv' + n; d.id = nid;
        [].forEach.call(sv.querySelectorAll('[clip-path],[style],[filter],[mask]'), function (x) {
          ['clip-path', 'filter', 'mask', 'style'].forEach(function (a) { var v = x.getAttribute(a); if (v && v.indexOf('#' + o + ')') >= 0) x.setAttribute(a, v.split('#' + o + ')').join('#' + nid + ')')); if (v && v.indexOf('#' + o + '"') >= 0) x.setAttribute(a, x.getAttribute(a).split('#' + o + '"').join('#' + nid + '"')); });
        });
      });
      sv.setAttribute('preserveAspectRatio', 'xMidYMid meet'); sv.removeAttribute('class'); sv.removeAttribute('style');
      sv.removeAttribute('width'); sv.removeAttribute('height'); sv.setAttribute('aria-hidden', 'true');
      var im = sv.querySelector('image'); if (im) { var h = im.getAttribute('href') || im.getAttribute('xlink:href'); im.setAttribute('href', sized(h, w)); }
      return sv;
    }
    var i = new Image(); i.alt = ''; i.decoding = 'async'; i.src = sized(ch.u, w); return i;
  }
  function srcOf(c, w) { var ch = CH[c]; if (ch.svg) { var im = ch.svg.querySelector('image'); return sized(im.getAttribute('href') || im.getAttribute('xlink:href'), w); } return sized(ch.u, w); }
  function put(holder, c, w) { holder.textContent = ''; holder.appendChild(render(c, w)); }
  function holderOf(s) { var h = s.querySelector('.pic'); if (!h) { h = el('span', 'pic'); s.insertBefore(h, s.firstChild); var old = s.querySelector(':scope > img'); if (old) old.remove(); } return h; }
  function show(i, c, quick) {
    var s = screens[i], h = holderOf(s); showing[i] = c;
    s.setAttribute('aria-label', 'Drawing ' + (c + 1));
    if (quick) { put(h, c, 700); s.classList.remove('zap'); return; }
    s.classList.add('zap');
    setTimeout(function () {
      var n = new Image(); n.onload = n.onerror = function () { put(h, c, 700); setTimeout(function () { s.classList.remove('zap'); }, 140); };
      n.src = srcOf(c, 700);
    }, 160);
  }
  var PS2 = [6.93, 29.5, 62.55, 52.33];
  /* the key: every TV jumps to the same drawing at once, and it rains money */
  var jp = false;
  function jackpot() {
    if (jp || !CH.length) return; jp = true;
    var k = wall.querySelector('.lgz-key'); k.classList.remove('spin'); void k.offsetWidth; k.classList.add('spin');
    var c = Math.random() * CH.length | 0;
    screens.forEach(function (s, i) { setTimeout(function () { show(i, c, false); }, i * 70); });
    if (window.lgzRain) window.lgzRain(30);
    setTimeout(function () { jp = false; fill(true); }, 5000);
  }
  var filled = false;
  /* never the same drawing on two TVs at once; if there are more TVs than drawings, the rest show snow */
  function free() { var f = []; for (var c = 0; c < CH.length; c++) if (showing.indexOf(c) < 0) f.push(c); return f; }
  function fill(all) {
    if (!CH.length) return;
    if (all) showing = showing.map(function () { return null; });
    screens.forEach(function (s, i) {
      if (showing[i] != null) return;
      var f = free(); if (!f.length) { s.classList.add('zap'); return; }
      var c = f[(i * 7) % f.length]; show(i, c, !all);
    });
    filled = true;
  }
  function frames() {
    if (has('ps2')) { var p = wall.querySelector('.lgz-ps2'); if (!p.querySelector(':scope > img')) { var pi = new Image(); pi.alt = ''; pi.className = 'lgz-keep'; pi.src = url('ps2'); p.appendChild(pi); } }
    if (has('key')) { var kb = wall.querySelector('.lgz-key'); if (!kb.firstChild) { var ki = new Image(); ki.alt = ''; ki.className = 'lgz-keep'; ki.src = url('key'); kb.appendChild(ki); } }
    if (has('frame')) { var f = wall.querySelector('.lgz-tv-frame'); if (!f.src) { f.onload = function () { f.classList.add('on'); }; f.src = url('frame'); } }
    if (['cbase', 'cA', 'cB', 'cC', 'cD'].every(has)) {
      var cams = wall.querySelector('.lgz-cams'); if (!cams.firstChild) {
        var b = new Image(); b.alt = ''; b.className = 'lgz-keep'; b.src = url('cbase'); cams.appendChild(b);
        var list = [];
        Object.keys(CAM).forEach(function (k) {
          var c = CAM[k], w = el('div', 'lgz-cam'); w.style.cssText = 'left:' + c.x + '%;top:' + c.y + '%;width:' + c.w + '%';
          var im = new Image(); im.alt = ''; im.className = 'lgz-keep'; im.src = url('c' + k); im.style.transformOrigin = c.ox + '% ' + c.oy + '%';
          w.appendChild(im); cams.appendChild(w);
          if (k === 'C') { var led = el('i'); led.style.left = '72%'; led.style.top = '42%'; w.appendChild(led); im.addEventListener('transitionrun', function () {}); w._led = led; }
          list.push({ k: k, c: c, w: w, im: im, p: 0, t: 0 });
        });
        watch(cams, list);
      }
    }
  }
  /* channels switch by themselves now and then (only while the TVs are on screen) */
  var onScreen = false;
  function zapper() {
    if (calm) return;
    setInterval(function () {
      if (!onScreen || document.hidden || !CH.length || box || jp) return;
      var f = free(); if (!f.length) return;
      var i = Math.random() * screens.length | 0; if (showing[i] == null) return;
      show(i, f[Math.random() * f.length | 0], false);
    }, 1700);
  }

  /* ---------- the cameras follow you ----------
     every camera turns on its own mount (pan = turning around the mount, tilt = nodding up/down),
     each a little late after the other, like real motorised cameras; nobody moving = each one scans on its own */
  var CAM = {"A": {"x": 0.0, "y": 32.83, "w": 33.373, "ox": 61.8, "oy": 90.4}, "B": {"x": 27.948, "y": 14.214, "w": 27.123, "ox": 60.0, "oy": 94.4}, "C": {"x": 50.472, "y": 0.0, "w": 27.83, "ox": 30.5, "oy": 95.5}, "D": {"x": 66.745, "y": 26.415, "w": 33.255, "ox": 45.7, "oy": 96.6}};
  /* which way the lens points in the photo: -1 = left, 1 = right */
  var FACE = { A: -1, B: -1, C: 1, D: 1 };
  function watch(cams, list) {
    var t = 0;
    function set(o, pan, tilt) {
      o.p = pan; o.t = tilt;
      o.im.style.transform = 'rotateY(' + pan.toFixed(1) + 'deg) rotateZ(' + tilt.toFixed(1) + 'deg)';
      if (o.w._led) o.w._led.style.transform = 'translateX(' + (pan * -0.25).toFixed(1) + 'px)';
    }
    function aim(x, y) {
      list.forEach(function (o, n) {
        var r = o.w.getBoundingClientRect(); if (!r.width) return;
        var px = r.left + r.width * o.c.ox / 100, py = r.top + r.height * o.c.oy / 100;
        var dx = (x - px) / Math.max(240, innerWidth * 0.55), dy = (y - py) / Math.max(240, innerHeight * 0.7);
        var f = FACE[o.k];
        /* the lens swings towards you: a camera looking left turns its nose to the right when you are on the right, etc */
        var pan = Math.max(-48, Math.min(48, -dx * 55 * f));
        if (f < 0 && dx < 0 || f > 0 && dx > 0) pan = Math.max(-20, Math.min(20, pan)); /* already looking that way: only a little */
        var tilt = Math.max(-16, Math.min(16, dy * 22 * f));
        clearTimeout(o.tm); o.tm = setTimeout(function () { set(o, pan, tilt); }, n * 90);
      });
      t = Date.now();
    }
    addEventListener('pointermove', function (e) { if (onScreen) aim(e.clientX, e.clientY); }, { passive: true });
    addEventListener('pointerdown', function (e) { if (onScreen) aim(e.clientX, e.clientY); }, { passive: true });
    if (calm) return;
    /* nobody moving: each camera scans the room on its own */
    list.forEach(function (o, n) {
      (function scan() {
        o.sc = setTimeout(function () {
          if (onScreen && Date.now() - t > 2500) set(o, (Math.random() * 2 - 1) * 40, (Math.random() * 2 - 1) * 9);
          scan();
        }, 1600 + Math.random() * 2600 + n * 200);
      })();
    });
  }

  /* ---------- a drawing opened big ---------- */
  var box = null, cur = 0, shopImg = '';
  function shopSrc() {
    if (shopImg) return shopImg;
    var s = document.querySelector('img[src*="lugazi-menu-shop"]'); shopImg = s ? (s.getAttribute('src') || '') : ''; return shopImg;
  }
  function open(c) {
    if (box) return;
    cur = c;
    box = el('div', 'lgz-tvx'); box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Drawing');
    box.innerHTML = '<button class="lgz-tvx-x" type="button" aria-label="Close">&#10005;</button>' +
      '<div class="lgz-tvx-scr"><img alt=""><i class="lgz-snow"></i></div>' +
      '<div class="lgz-tvx-bar"><button type="button" class="lgz-tvx-p" aria-label="Previous">&#9664;</button><span class="lgz-tvx-ch"></span><button type="button" class="lgz-tvx-n" aria-label="Next">&#9654;</button></div>' +
      '<a class="lgz-tvx-buy" href="#" aria-label="Shop"><img alt="Shop"></a>';
    var sn = box.querySelector('.lgz-snow'); if (SNOW) sn.style.backgroundImage = 'url(' + SNOW + ')';
    box.querySelector('.lgz-tvx-buy img').src = shopSrc();
    document.body.appendChild(box);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { box.classList.add('on'); });
    tune(0);
    box.querySelector('.lgz-tvx-x').addEventListener('click', close);
    box.querySelector('.lgz-tvx-p').addEventListener('click', function () { tune(-1); });
    box.querySelector('.lgz-tvx-n').addEventListener('click', function () { tune(1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    var sx = null, sy = 0;
    box.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
    box.addEventListener('pointerup', function (e) {
      if (sx == null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) tune(dx < 0 ? 1 : -1);
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.5) close();
    });
    try { history.pushState({ lgzTv: 1 }, ''); } catch (e) {}
    box.querySelector('.lgz-tvx-n').focus({ preventScroll: true });
  }
  function tune(d) {
    if (!box) return;
    cur = (cur + d + CH.length) % CH.length;
    var scr = box.querySelector('.lgz-tvx-scr'), c = CH[cur], k0 = cur;
    box.querySelector('.lgz-tvx-ch').textContent = 'CH ' + (cur + 1 < 10 ? '0' : '') + (cur + 1);
    scr.classList.add('zap');
    var n = new Image(); n.onload = n.onerror = function () { if (!box || cur !== k0) return; put(holderOf(scr), k0, 1600); setTimeout(function () { scr.classList.remove('zap'); }, d ? 140 : 60); };
    n.src = srcOf(k0, 1600);
    /* the drawings that are prints you can buy keep their shop link */
    var buy = box.querySelector('.lgz-tvx-buy'), h = c.pg && c.pg.dataset ? c.pg.dataset.lgzBuy : '';
    if (h) { buy.dataset.lgzBuy = h; buy.classList.add('on'); } else { delete buy.dataset.lgzBuy; buy.classList.remove('on'); }
    /* preload the neighbours */
    [1, -1].forEach(function (k) { var p = new Image(); p.src = srcOf((cur + k + CH.length) % CH.length, 1600); });
  }
  function close(fromBack) {
    if (!box) return; var b = box; box = null;
    b.classList.remove('on'); document.documentElement.style.overflow = '';
    setTimeout(function () { b.remove(); }, 220);
    if (fromBack !== true) { try { if (history.state && history.state.lgzTv) history.back(); } catch (e) {} }
  }
  addEventListener('popstate', function () { if (box) close(true); });
  addEventListener('keydown', function (e) {
    if (!box) return;
    if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') tune(1); else if (e.key === 'ArrowLeft') tune(-1);
  });

  /* ---------- the end: ransom letters + the hand on the edge ---------- */
  var endDone = false;
  function ending() {
    if (endDone || !has('hand')) return;
    endDone = true;
    /* the hand: someone hangs on to the top TV (fingers over its top edge) */
    var stack = wall && wall.querySelector('.lgz-tv-stack');
    if (stack) {
      var hand = new Image(); hand.alt = ''; hand.className = 'lgz-grip lgz-keep'; hand.src = url('hand'); hand.setAttribute('aria-hidden', 'true');
      stack.appendChild(hand);
      /* tap the hand: it lets go and is gone */
      hand.addEventListener('click', function (e) { e.stopPropagation(); hand.classList.add('bye'); setTimeout(function () { hand.remove(); }, 500); });
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) setTimeout(function () { hand.classList.add('on'); }, 500); }); }, { threshold: 0.4 }).observe(stack);
    }
  }

  /* ---------- the eye on the first screen: looks at you, blinks ---------- */
  function eye() {
    if (!['eyeS', 'eyeL', 'eyeI'].every(has)) return;
    var host = document.querySelector('#lugazi-scene-1'); if (!host || host.querySelector('.lgz-eye')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var e = el('div', 'lgz-eye'); e.setAttribute('aria-hidden', 'true');
    [['eyeS', 's'], ['eyeI', 'i'], ['eyeL', 'l']].forEach(function (p) { var im = new Image(); im.alt = ''; im.className = 'lgz-keep ' + p[1]; im.src = url(p[0]); e.appendChild(im); });
    host.appendChild(e);
    var iris = e.querySelector('.i'), last = 0;
    function look(x, y) {
      var r = e.getBoundingClientRect(); if (!r.width || r.bottom < 0 || r.top > innerHeight) return;
      var dx = x - (r.left + r.width / 2), dy = y - (r.top + r.height / 2), d = Math.hypot(dx, dy) || 1, k = Math.min(1, d / 300);
      iris.style.transform = 'translate(' + (dx / d * k * r.width * 0.11).toFixed(1) + 'px,' + (dy / d * k * r.height * 0.07).toFixed(1) + 'px)';
      last = Date.now();
    }
    addEventListener('pointermove', function (ev) { look(ev.clientX, ev.clientY); }, { passive: true });
    addEventListener('pointerdown', function (ev) { look(ev.clientX, ev.clientY); }, { passive: true });
    if (calm) return;
    setInterval(function () {
      if (document.hidden) return;
      if (Math.random() < 0.6) { e.classList.remove('blink'); void e.offsetWidth; e.classList.add('blink'); }
      if (Date.now() - last > 3000) { var r = e.getBoundingClientRect(); look(r.left + r.width / 2 + (Math.random() * 2 - 1) * 300, r.top + r.height / 2 + (Math.random() * 2 - 1) * 150); last = 0; }
    }, 2600);
  }

  /* ---------- go ---------- */
  /* ---------- the compact start page ---------- */
  function front() {
    var hero = document.querySelector('#lugazi-scene-1 .lw-stage') || document.querySelector('#lugazi-scene-1'); if (!hero || hero.querySelector('.lgz-front')) return true;
    var M = window.__lgzMenuP; if (!M || !['shop', 'drawings'].every(function (k) { return M[k] && M[k].n && M[k].filter(Boolean).length === M[k].n; })) return false;
    if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
    var box = el('nav', 'lgz-front'); box.setAttribute('aria-label', 'LUGAZI');
    [['f-shop', 'shop', '/collections/all', 'Shop'], ['f-draw', 'drawings', '/?lugazi=book', 'Drawings + Stuff']].forEach(function (q) {
      var a = el('a', q[0]); a.href = q[2]; a.setAttribute('aria-label', q[3]);
      var im = new Image(); im.alt = ''; im.className = 'lgz-keep'; im.src = M[q[1]].join(''); a.appendChild(im); box.appendChild(a);
    });
    hero.appendChild(box);
    /* the signs belong to the first screen: they fade away as soon as you scroll on */
    var sc = document.querySelector('#lugazi-scene-1');
    var upd = function () { var r = sc.getBoundingClientRect(); box.classList.toggle('off', r.top < -innerHeight * 0.12); };
    addEventListener('scroll', upd, { passive: true }); document.addEventListener('scroll', upd, { passive: true, capture: true }); upd();
    return true;
  }
  function money(cents) { return (Math.round(cents) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr'; }
  function drop() {
    if (document.querySelector('.lgz-drop')) return;
    fetch('/collections/all/products.json?limit=40').then(function (r) { return r.json(); }).then(function (d) {
      var ps = (d.products || []).filter(function (p) { return !/print/i.test(p.product_type || '') && p.images && p.images.length; });
      ps.sort(function (a, b) { return Date.parse(b.published_at) - Date.parse(a.published_at); });
      ps = ps.slice(0, 4); if (!ps.length) return;
      var sec = el('section', 'lgz-drop'); sec.setAttribute('aria-label', 'New');
      var shopSign = document.querySelector('img[src*="lugazi-menu-shop"]');
      var h = el('a', 'lgz-drop-h'); h.href = '/collections/all'; h.setAttribute('aria-label', 'Shop');
      if (shopSign) { var hi = new Image(); hi.alt = ''; hi.src = shopSign.getAttribute('src'); h.appendChild(hi); }
      sec.appendChild(h);
      var row = el('div', 'lgz-drop-row'); sec.appendChild(row);
      ps.forEach(function (p) {
        var a = el('a', 'lgz-drop-card'); a.href = '/products/' + p.handle;
        var u = p.images[0].src; u += (u.indexOf('?') < 0 ? '?' : '&') + 'width=600';
        var pr = Math.min.apply(null, p.variants.map(function (v) { return Math.round(parseFloat(v.price) * 100); }));
        a.innerHTML = '<span class="im"><img alt="" loading="lazy" decoding="async"></span><span class="t"></span><span class="p"></span>';
        a.querySelector('img').src = u; a.querySelector('img').alt = p.title; a.querySelector('.t').textContent = p.title; a.querySelector('.p').textContent = money(pr);
        row.appendChild(a);
      });
      var t = document.querySelector('.lgz-ds-title'); if (t && t.parentNode) t.parentNode.insertBefore(sec, t); else book.insertBefore(sec, wall || book.firstChild);
    }, function () {});
  }
  function compactStart() {
    if (!compact) return;
    drop();
    /* ask the menu for its signs right away (it fetches them on its own after a moment) */
    var tg = document.querySelector('.lc-menu-toggle'); if (tg) try { tg.dispatchEvent(new PointerEvent('pointerover', { bubbles: true })); } catch (e) {}
    var n = 0, iv = setInterval(function () { if (front() || ++n > 40) clearInterval(iv); }, 250);
  }

  function start() {
    build();
    compactStart();
    harvest();
    var tries = 0, iv = setInterval(function () { harvest(); if (++tries > 30) clearInterval(iv); }, 400);
    addEventListener('load', function () { harvest(); setTimeout(harvest, 1500); });
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }, { rootMargin: '100px' }).observe(wall);
    zapper();
    /* the pictures: TVs + cameras first, letters + hand once the page has settled */
    loadAll('lugazi-tvb', NTV, frames);
    loadAll('lugazi-cam', NCAM, frames);
    /* 24 Oct: no eye on the first screen (Leandro) */
    var endAsked = false, endGo = function () { if (endAsked) return; endAsked = true; loadAll('lugazi-hand', NEND, ending); };
    setTimeout(endGo, 3500);
    addEventListener('scroll', function sc() { if (scrollY > 2500) { endGo(); removeEventListener('scroll', sc); } }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
